import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = {
  class: "payment-method",
  ref: "paymentMethodContainer"
}
const _hoisted_2 = { class: "payment-body" }
const _hoisted_3 = {
  key: 0,
  class: "payment-icon"
}
const _hoisted_4 = /*#__PURE__*/_createElementVNode("svg", {
  width: "46",
  height: "32",
  viewBox: "0 0 46 32",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M5 0C2.25 0 0 2.25 0 5V27C0 29.75 2.25 32 5 32H41C43.75 32 46 29.75 46 27V5C46 2.25 43.75 0 41 0H5ZM5 2H41C42.668 2 44 3.33203 44 5V7H2V5C2 3.33203 3.33203 2 5 2ZM2 12H44V27C44 28.668 42.668 30 41 30H5C3.33203 30 2 28.668 2 27V12ZM7 15V17H23V15H7Z",
    fill: "#F2C94C"
  })
], -1 /* HOISTED */)
const _hoisted_5 = [
  _hoisted_4
]
const _hoisted_6 = {
  key: 1,
  class: "payment-icon"
}
const _hoisted_7 = /*#__PURE__*/_createElementVNode("svg", {
  width: "23",
  height: "12",
  viewBox: "0 0 23 12",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M22.1533 9.23031V11.0764C22.1533 11.4327 21.9475 11.7576 21.6253 11.9109C21.3032 12.0641 20.922 12.017 20.645 11.7909L11.0767 3.96152L1.50735 11.7909C1.23135 12.017 0.850133 12.0632 0.527064 11.9109C0.203995 11.7586 0 11.4327 0 11.0764L0 9.23031C0 8.9534 0.124612 8.69125 0.338761 8.51587L10.4924 0.208379C10.833 -0.0694606 11.3213 -0.0694606 11.6619 0.208379L21.8155 8.51587C22.0287 8.69125 22.1533 8.9534 22.1533 9.23031Z",
    fill: "#CFCFCF"
  })
], -1 /* HOISTED */)
const _hoisted_8 = { class: "payment-description" }
const _hoisted_9 = {
  key: 0,
  class: "payment-info"
}
const _hoisted_10 = {
  key: 1,
  class: "payment-info"
}
const _hoisted_11 = { class: "payment-text" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      ($props.payment.type == 'credit')
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, _hoisted_5))
        : ($props.payment.type == 'bank')
          ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
              _createCommentVNode("TODO: Replace placeholder image here"),
              _hoisted_7
            ]))
          : _createCommentVNode("v-if", true),
      _createElementVNode("div", _hoisted_8, [
        ($props.payment.type == 'credit')
          ? (_openBlock(), _createElementBlock("div", _hoisted_9, "Credit Card"))
          : (_openBlock(), _createElementBlock("div", _hoisted_10, "Payment Method")),
        _createElementVNode("div", _hoisted_11, _toDisplayString($props.payment.nickname), 1 /* TEXT */)
      ])
    ])
  ], 512 /* NEED_PATCH */))
}